import { PageName } from "./App"

export const popPage = () => {
    window.history.back()
}